import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {select, highlightActiveBlock} from '../../actions/index';
import {Link} from 'react-router-dom';
import {closeNavBar, setCurrentElement} from "../../actions/index";
import "./ChapterList.css";
import {hightlightActiveItem} from "../../actions";

class ChapterList extends Component {


    componentDidMount() {
    }

    componentDidUpdate() {
    }

    highlightCurrentChapter(id) {
        this.props.highlightActiveBlock(id);
    }

    highlightCurrentItem(itemId) {
        this.props.highlightActiveItem(itemId)
    }

    showChapter(chapter) {
        let pathArray = window.location.href.split("/");
        let courseId = pathArray[pathArray.indexOf("course") + 1];
        if (this.props.chapter_active.node_id === chapter.node_id) {
            this.highlightCurrentChapter(chapter.node_id)
        }

        let par_current_classes = chapter.node_id === this.props.active_block ? "paragraph-current active" : "paragraph-current";

        return (

            <div id={chapter.node_id} href="#" className={par_current_classes} key={chapter.node_id}
                 style={{zIndex: '100'}}
            >

                <ul className="paragraph-title-wrapper">
                    <li>
                        <div className="paragraph-title">
                            <div className="paragraph-text" onClick={
                                () => {
                                    this.props.closeNavBar();
                                }

                            }>
                                <Link
                                    to={"/viewer/course/" + courseId + "/nodes/" + chapter.node_id}
                                    onClick={() => {
                                        this.props.previous(chapter.node_id, null, this.props.allElements, courseId)
                                    }}
                                >
                                    {chapter.text}
                                </Link>
                            </div>

                        </div>
                    </li>
                    <div className="paragraph-text">
                        {/*<Link to={"/viewer/course/" + courseId + "/nodes/" + chapter.node_id}>{chapter.text}</Link>*/}

                        {this.iterate(chapter.nodes)}
                    </div>
                </ul>
            </div>
        );
    }

    showSubChapter(chapter, mainParentId) {

        let pathArray = window.location.href.split("/");
        let styleBord = "";
        if (this.props.active_item.nodeId === chapter.node_id) {
            styleBord = "chapter_selected_item";
        }

        let courseId = pathArray[pathArray.indexOf("course") + 1];
        if (this.props.chapter_active.node_id === chapter.node_id) {
            this.highlightCurrentChapter(mainParentId);
        }
        return (
            <div className={"paragraph-text-child " + styleBord} key={chapter.node_id}
                 style={{border: styleBord}}>
                <Link to={"/viewer/course/" + courseId + "/nodes/" + chapter.node_id}
                      key={chapter.node_id}
                      onClick={(e) => {
                          this.props.previous(chapter.node_id, null, this.props.allElements)
                      }}
                >
                    {chapter.text}
                </Link>
                {
                    this.iterate(chapter.nodes)
                }
            </div>
        );
    }

    iterate(chapters) {
        return chapters.map(
            (chapter) => {
                if (chapter.node_parent_id == null) {
                    this.mainParentId = chapter.node_id;
                    return this.showChapter(chapter);
                }
                else
                    return this.showSubChapter(chapter, this.mainParentId);

            }
        );
    }

    render() {
        let course_structure = this.props.chapters.chaptersList;
        if (this.props.chapters.chaptersList.length !== 0 && this.props.chapters.chaptersList !== undefined) {
            course_structure = this.props.chapters.chaptersList[0]["nodes"];
        }
        return (
            <div className="book-paragpraphs-wrapper"
                 onClick={() => this.props.closeNavBar()}>

                {this.iterate(course_structure)}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    chapters: state.chapters,
    chapter_active: state.active,
    active_block: state.active_block,
    active_item: state.active_item,
    allElements: state.allElements,
    chapterContent: state.chapterContent
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        // select: select,
        highlightActiveBlock: highlightActiveBlock,
        highlightActiveItem: hightlightActiveItem,
        closeNavBar: closeNavBar,
        previous: setCurrentElement
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ChapterList);



// WEBPACK FOOTER //
// ./src/containers/ChapterList/ChapterList.js